var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contact-details" },
    [
      _c(
        "CompassTooltip",
        { attrs: { content: _vm.labelTooltipAction } },
        [
          _vm.variant === _vm.ENUMS_VARIANT.PHONE
            ? _c("CompassLink", {
                attrs: {
                  label: _vm._f("formatPhoneNumber")(
                    _vm.value,
                    _vm.phoneFormat
                  ),
                  link: _vm.phonecallProtocol + ":" + _vm.value
                }
              })
            : _c("CompassPlainButton", {
                attrs: { label: _vm.value },
                on: { click: _vm.handleSendEmail }
              })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "CompassTooltip",
        { attrs: { content: _vm.$t.__("common.actions.copy") } },
        [
          _c("CompassIconButton", {
            attrs: { size: "small", icon: "duplicate" },
            on: {
              click: function($event) {
                return _vm.onCopyToClipboard(_vm.value)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }